import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "../../state";

export enum SeverityTypes {
  ERROR = "error",
  WARNING = "warning",
  INFO = "info",
  SUCCESS = "success",
}

export interface NotificationData {
  open: boolean;
  message: string | undefined;
  severity: SeverityTypes | undefined;
}

const initialState = {
  open: false,
  message: undefined,
  severity: undefined,
};

export const notificationSlice = createSlice({
  name: "notificationSlice",
  initialState,
  reducers: {
    setNotification: (state, action) => {
      return {
        open: action.payload.open,
        message: action.payload.message,
        severity: action.payload.severity,
      };
    },
  },
});

export const selectNotification = (state: RootState): NotificationData =>
  state.notification;

export const { setNotification } = notificationSlice.actions;
export default notificationSlice.reducer;
